import ListSubheader from "@mui/material/ListSubheader";

// Bold, shaded and sticky so a category reads as a section, not as a product row.
export default function ProductCategoryGroupHeading({
  children
}: {
  children: string;
}) {
  return (
    <ListSubheader
      data-testid="product-category-group"
      sx={{
        top: -8,
        lineHeight: "32px",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "text.primary",
        bgcolor: "grey.100",
        borderBottom: (theme) => `0.5px solid ${theme.palette.divider}`
      }}
    >
      {children}
    </ListSubheader>
  );
}
